import { Dashboard } from '@mui/icons-material';

export const RootRoutes = {
	Root: '/',
	StylesExamples: '/styles-examples',
	Auth: '/auth',
	Profile: '/profile',
	Survey: '/surveys',
	Dashboard: '/dashboard',
	Analytics: '/analytics',
	NotFound: '*',
};
